import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Color from '../../styles/common/Color';

const Wrapper = styled.div`
  min-width: 28px;
  height: 19px;
  display: flex;
  align-items: center;
  margin: 4px;
  padding: 2px 4px;
  background-color: ${props => props.color};
  border-radius: 2px;
  font-size: 10px;
  color: #fff;
`;

export const RequiredChip = () => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const text = formatMessage({ id: 'common.label.required' });
  return <Chip text={text} bgColor={Color.red} />;
};

export const Chip = ({ text, bgColor }) => (
  <Wrapper color={bgColor}>{text}</Wrapper>
);
Chip.propTypes = {
  text: PropTypes.string.isRequired,
  bgColor: PropTypes.string.isRequired,
};
